import { render, staticRenderFns } from "./roleinfo.vue?vue&type=template&id=751a9970"
import script from "./roleinfo.vue?vue&type=script&lang=js"
export * from "./roleinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports